import React, { FC, useEffect, useState, useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import { handlerGetProperties } from '../../createNode'
import JsonSchemaForm from '@/components/schemaForm'
import configList from './configList'
import Control from '../control'
import { Form } from 'antd'
const baseUrl = `https://baleen-cdn-g.bybieyang.com/`

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
}
interface ConfigProps {
  instance: any
}

const Config: FC<ConfigProps> = ({ instance }) => {
  const [form] = Form.useForm()
  const [activeObjectProperties, setActiveObjectProperties] = useState<any>()
  const [nodeType, setNodeType] = useState('default')
  const updateActiveObjectState = useCallback(() => {
    const activeObject = instance?.getActiveObject()
    setNodeType(activeObject?.type || 'default')
    if (activeObject) {
      const property = {
        ...handlerGetProperties(activeObject),
        scaledHeight: activeObject.getScaledHeight(),
        scaledWidth: activeObject.getScaledWidth(),
        ...(activeObject.type === 'image'
          ? {
              src: [{ url: activeObject.getSrc() }],
            }
          : {}),
        ...(activeObject.type === 'i-text'
          ? {
              fontSize: activeObject.fontSize,
              fontStyle: activeObject.fontStyle,
              fontWeight: activeObject.fontWeight,
              fontFamily: activeObject.fontFamily,
              shadow: activeObject.shadow,
              textAlign: activeObject.textAlign,
            }
          : {}),
        ...(activeObject.type === 'rect'
          ? {
              fill: activeObject.fill,
            }
          : {}),
      }
      setActiveObjectProperties(property)
    } else {
      setActiveObjectProperties(null)
    }
  }, [instance])

  const activeConfig = useMemo(() => {
    return configList[nodeType]
  }, [nodeType])

  useEffect(() => {
    instance?.on('selection:created', function () {
      updateActiveObjectState()
    })
    instance?.on('selection:updated', function () {
      updateActiveObjectState()
    })
    instance?.on('selection:cleared', function () {
      updateActiveObjectState()
    })
    instance?.on('object:modified', function () {
      updateActiveObjectState()
    })
    return () => {
      instance?.removeListeners()
    }
  }, [instance, updateActiveObjectState])

  useEffect(() => {
    form.resetFields()
  }, [form, activeObjectProperties])

  const handerResetObject = (field, value) => {
    const activeObject = instance?.getActiveObject()
    if (activeObject) {
      switch (field) {
        case 'scaledHeight':
          activeObject.scaleToHeight(value)
          instance?.requestRenderAll()
          break
        case 'scaledWidth':
          activeObject.scaleToWidth(value)
          instance?.requestRenderAll()
          break
        case 'src':
          const url = value.length && value[0].response?.name
          url &&
            activeObject.setSrc(
              `${baseUrl}${url}`,
              () => {
                instance?.requestRenderAll()
              },
              {
                crossOrigin: 'anonymous',
              }
            )
          break
        case 'fill':
          const { hex } = value
          activeObject.set('fill', hex).setCoords()
          instance?.requestRenderAll()
          break
        default:
          activeObject.set(field, value).setCoords()
          instance?.requestRenderAll()
      }
    }
  }
  const onFieldsChange = (data: any) => {
    data.length && handerResetObject(data[0].name[0], data[0].value)
  }

  return (
    <div className="material-config">
      {activeObjectProperties && <Control instance={instance} />}
      <JsonSchemaForm
        schema={activeConfig}
        initialValues={activeObjectProperties}
        form={form}
        {...layout}
        onFieldsChange={onFieldsChange}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  instance: state.material.instance,
})

export default connect(mapStateToProps)(Config)
